import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const Loading: FunctionalComponent<IIconProps> = ({ width = '16', height = '16' }) => {
  return (
    /*@ts-ignore*/
    <svg
      class="loading-wrap-svg"
      viewBox="25 25 50 50"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={{
        width: '100%',
        height: '100%',
        transformOrigin: 'center center',
        position: 'absolute',
        top: '0',
        bottom: '0',
        margin: 'auto',
      }}
    >
      <circle cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
  );
};

export default Loading;
